import { render, staticRenderFns } from "./CharacterDebug.vue?vue&type=template&id=f9daaea2&scoped=true&"
import script from "./CharacterDebug.vue?vue&type=script&lang=js&"
export * from "./CharacterDebug.vue?vue&type=script&lang=js&"
import style0 from "./CharacterDebug.vue?vue&type=style&index=0&id=f9daaea2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9daaea2",
  null
  
)

export default component.exports